import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import Header from './components/Header';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Footer from './components/Footer';
import Aboutus from './pages/Aboutus';
import TermsConditionsLotusCab from './pages/TermsConditions';
import PrivacyPolicyLotusCab from './pages/PrivacyPolicy';
import LotusServices from './pages/LotusServices';
import OurFleet from './pages/OurFleet';
import Packages from './pages/Packages';
import PortfolioSection from './pages/Gallery';
import Gallery from './pages/Gallery';
import ContactDetails from './pages/ContactDetails';
import Enquiry from './pages/Enquiry';
import Booking from './pages/Booking';
import Punetaxifare from './pages/Pune Taxi Fare';
import Puneoutstaiontaxihire from './pages/Pune Outstation Taxi Hire';
import Pimprichichwadonlinecab from './pages/Pimpri Chinchwad Online Cab';
import Bestcabserviceinpune from './pages/Best Cab Service in Pune';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cabs';
import Punetonashikcabs from './pages/Pune to Nasik Cabs';
import ScrollToTop from './components/ScrollToTop';
import Punetomahabaleshwarcab from './pages/Pune to Mahabaleshwar Cabs';
import Punetolonavalacabbooking from './pages/Pune to Lonavala Cab Booking';
import Punetoshirdicab from './pages/Pune to Shirdi Cabs';
import Punetolavasacitycab from './pages/Pune to Lavasa City Cabs';
import Punetobhimashankarcabs from './pages/Pune Airport to Bhimashankar Cabs';
import Punetoindorecabs from './pages/Pune to Indore Cabs';
import Punetokonkandarshancab from './pages/Pune to Konkan Darshan Cabs';
import Punecabfare from './pages/Pune Cab Fare';
import Oustationtaxiservicepune from './pages/Outstation Taxi Service Pune';
import Punetopanchganicabbooking from './pages/Pune to Panchgani Cab Booking';
import Punetomumbaiinternationalairporttaxi from './pages/Pune to Mumbai International Airport Taxi';
import Ashtavinayakdarshancabpackage from './pages/Ashtavinayak Darshan Cab Package';
import Punetonagpurcabs from './pages/Pune To Nagpur Cabs';
import Cabserviceinkharadi from './pages/Cab Service in Kharadi';
import Taxiserviceinhinjewadipune from './pages/Taxi Service in Hinjewadi Pune';
import Punetogujratcabservice from './pages/Pune to Gujarat Cab Service';
import Travelsagentsinpune from './pages/Travel Agents in Pune';
import Punetothanecab from './pages/Pune to Thane Cab';
import Punetobangloretaxiservice from './pages/Pune to Bangalore Taxi Service';
import Punetogoacabs from './pages/Pune to Goa Cabs';
import Punetoajantaelloracabs from './pages/Pune to Ajanta Ellora Cabs';
import Punetosataracabs from './pages/Pune to Satara Cabs';
import Puneairportcabs from './pages/Pune Airport Cabs';
import Cabsservicesnearme from './pages/Cabs Services Near Me';
import Corporatecabserviceinpune from './pages/Corporate Cab Service in Pune';
import Punetomumbaiairportcabs from './pages/Pune to Mumbai Airport Cabs';
import Punetokolhapurcabs from './pages/Pune to Kolhapur Cab';
import Punetopandharpurtaxi from './pages/Pune to Pandharpur Taxi';
import Tempotravelleronrentinpune from './pages/Tempo Traveller on Rent in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta On Rent in Pune';
import Innovacabsonrentinpune from './pages/Innova Cabs on Rent in Pune';
import Volkswagenventoonrent from './pages/Volkswagen Vento On Rent';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent In Pune';
import Punetoimagicataxi from './pages/Pune to Imagica Taxi';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Kiacarenceonrentinpune from './pages/Kia Carens On Rent in Pune';
import Punetosambhajinagartaxifare from './pages/Pune to Sambhaji Nagar Taxi fare';
import Punetoganapaticabs from './pages/Pune to Ganpatipule Cabs';
import Punetoharihareshwartaxifare from './pages/Pune to Harihareshwar Taxi Fare';
import Punetoalibaugcabs from './pages/Pune to Alibag Cabs';
import Punetopanvelcabs from './pages/Pune to Panvel Cabs';
import Punetohyderabadcabs from './pages/Pune to Hyderabad Cabs';
import Punetofivejyotilingacab from './pages/Pune to 5 Jyotrilinga Cab';
import Cabbookinginpunne from './pages/Cab Booking in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Explorerpanindiacabservicefrompune from './pages/Explorer pan India cab service from Pune';
import Mumbaidarshancabsservice from './pages/Mumbai Darshan Cabs Service';
import Mumbaitishirdicabs from './pages/Mumbai to Shirdi Cabs';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cabs';
import Mumbaitopunecabservice from './pages/Mumbai to Pune Cab Service';
import Mumbaitomahabaleshwartaxi from './pages/Mumbai to Mahabaleshwar Taxi';
import Mumbaitokonkandarshancab from './pages/Mumbai to Konkan Darshan Cab';
import Mumbaitogoacabservice from './pages/Mumbai to Goa Cab Service';
import Mumbaitonashikcab from './pages/Mumbai to Nashik Cab';
import Mumbaiairportcabservice from './pages/Mumbai Airport Cab Service';
import Mumbaitooutstationcabs from './pages/Mumbai to Outstation Cabs';
import Onlinetaxibookingmumbai from './pages/Online Taxi Booking Mumbai';
import Outstationtaxiserviceinthane from './pages/Outstation Taxi Service in Thane';
import Mumbaitofivejyotilingadarshancab from './pages/Mumbai to 5 Jyotirlinga Darshan Cab';
import Mumbaitokolhapurcabs from './pages/Mumbai to Kolhapur Cabs';
import Cheapestcabserviceinmumbai from './pages/Cheapest Cab Service in Mumbai';
import Mumbaitoashtavinayakdarshancabservice from './pages/Mumbai to Ashtavinayak Darshan Cab Service';
import Taxiserviceinhadapsar from './pages/Taxi Service in Hadapsar';
import Taxiserviceinlohegaon from './pages/Taxi Service in Lohegaon';
import Cabserviceinvimannagar from './pages/Cab Service in Viman Nagar';
import Onewaycabpune from './pages/One Way Cab Pune';
import Punetooustationcabs from './pages/Pune to Outstations Cabs';
import Punetomatherancabs from './pages/Pune to Matheran Cabs';
import Punetofivejyotilingadarshancabs from './pages/Pune to 5 Jyotirlinga Darshan Cab';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Punetoaurangabadcab from './pages/Pune to Aurangabad Cab Service';
import Punetonashikcabservice from './pages/Pune to Nashik Cab Service';
import Punetoalibaugcab from './pages/Pune to Alibaug Cab';
import Goatopunecabs from './pages/Goa to Pune Cabs';
import Innovacrystacabinpune from './pages/Innova Crysta Cab in Pune';
import Punetoashtavinayakcabs from './pages/Pune to Ashtavinayak Cabs';
import Mumbaioutstationcabbooking from './pages/Mumbai Outstation Cab Booking';
import Cabserviceinnavimumbai from './pages/Cab Service in Navi Mumbai';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta On Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga On Rent in Mumbai';
import Cabserviceinthane from './pages/Cab Service in Thane';
import Mumbaitoalibaugcab from './pages/Mumbai to Alibaug Cab';
import Navimumbaiinternatinalairportcab from './pages/Navi Mumbai International Airport Cabs';
import ContactButtons from './components/ContactButtons';
import Goatopunecabservice from './pages/Goa to Pune Cab Service';
import Punetogoainnovarental from './pages/Pune to Goa Innova Rental';
import Goatopimprichichwad from './pages/Goa to Pimpri Chinchwad Cab ';
import Goatopuneonewaycab from './pages/Goa to Pune One Way Cab';
import Goatopunetaxi from './pages/Goa to Pune Taxi';
import Punetogoataxi from './pages/Pune to Goa Taxi';
import Punetogoacabpackage from './pages/Pune to Goa Cab Package';
import Punetogoataxifare from './pages/Pune to Goa Taxi Fare One Way';
import Punetogoataxifareoneway from './pages/Pune to Goa Taxi Fare One Way';
import Pimprichichwadtogoacab from './pages/Pimpri Chinchwad to Goa Cab';
import Punetogoataxiservice from './pages/Pune to Goa Taxi Service';
import Punetogoaertigacabbooking from './pages/Pune to Goa Ertiga Cab Booking';
import Punetogoatourpackagesforfamily from './pages/Pune to Goa Tour Packages for Family';
import Punetoogoatwodayspackages from './pages/Pune to Goa 2 Days Package';
import Punetogoathreedayspackages from './pages/Pune to Goa 3 Days Package';
import Punetogoainnnovacab from './pages/Pune to Goa Innova Cab';
import Goapackagesfrompuneforfamily from './pages/Goa Packages from Pune for Family';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';



function App() {



  return (
    <Router>
      <ScrollToTop />
      <Header />
      <ContactButtons />

      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/term-condition" element={<TermsConditionsLotusCab />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyLotusCab />} />
        <Route path="/services" element={<LotusServices />} />
        <Route path="/our-fleet" element={<OurFleet />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactDetails />} />
        <Route path="/enquiry" element={<Enquiry />} />




        <Route path="/Pune-Taxi-Fare" element={<Punetaxifare />} />

<Route path="/Pune-Outstation-Taxi-Hire" element={<Puneoutstaiontaxihire />} />
<Route path="/Pimpri-Chinchwad-Online-Cab" element={<Pimprichichwadonlinecab />} />
<Route path="/Best-Cab-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-to-Mumbai-One-Way-Cabs" element={<Punetomumbaionewaycab />} />
<Route path="/Pune-to-Nasik-Cabs" element={<Punetonashikcabs />} />
<Route path="/Pune-to-Mahabaleshwar-Cabs" element={<Punetomahabaleshwarcab />} />
<Route path="/Pune-to-Lonavala-Cab-Booking" element={<Punetolonavalacabbooking />} />
<Route path="/Pune-to-Shirdi-Cabs" element={<Punetoshirdicab />} />
<Route path="/Pune-to-Lavasa-City-Cabs" element={<Punetolavasacitycab />} />
<Route path="/Pune-Airport-to-Bhimashankar-Cabs" element={<Punetobhimashankarcabs />} />
<Route path="/Pune-to-Indore-Cabs" element={<Punetoindorecabs />} />
<Route path="/Pune-to-Konkan-Darshan-Cabs" element={<Punetokonkandarshancab />} />
<Route path="/Pune-Cab-Fare" element={<Punecabfare />} />
<Route path="/Outstation-Taxi-Service-Pune" element={<Oustationtaxiservicepune />} />
<Route path="/Pune-to-Panchgani-Cab-Booking" element={<Punetopanchganicabbooking />} />
<Route path="/Pune-to-Mumbai-International-Airport-Taxi" element={<Punetomumbaiinternationalairporttaxi />} />
<Route path="/Ashtavinayak-Darshan-Cab-Package" element={<Ashtavinayakdarshancabpackage />} />
<Route path="/Pune-To-Nagpur-Cabs" element={<Punetonagpurcabs />} />
<Route path="/Cab-Service-in-Kharadi" element={<Cabserviceinkharadi />} />
<Route path="/Taxi-Service-in-Hinjewadi-Pune" element={<Taxiserviceinhinjewadipune />} />
<Route path="/Pune-to-Gujarat-Cab-Service" element={<Punetogujratcabservice />} />
<Route path="/Travel-Agents-in-Pune" element={<Travelsagentsinpune />} />
<Route path="/Pune-to-Thane-Cab" element={<Punetothanecab />} />
<Route path="/Pune-to-Bangalore-Taxi-Service" element={<Punetobangloretaxiservice />} />
<Route path="/Pune-to-Goa-Cabs" element={<Punetogoacabs />} />
<Route path="/Pune-to-Ajanta-Ellora-Cabs" element={<Punetoajantaelloracabs />} />
<Route path="/Pune-to-Satara-Cabs" element={<Punetosataracabs />} />
<Route path="/Pune-Airport-Cabs" element={<Puneairportcabs />} />
<Route path="/Cabs-Services-Near-Me" element={<Cabsservicesnearme />} />
<Route path="/Corporate-Cab-Service-in-Pune" element={<Corporatecabserviceinpune />} />





<Route path="/Pune-to-Mumbai-Airport-Cabs" element={<Punetomumbaiairportcabs />} />
<Route path="/Pune-to-Kolhapur-Cab" element={<Punetokolhapurcabs />} />
<Route path="/Pune-to-Pandharpur-Taxi" element={<Punetopandharpurtaxi />} />
<Route path="/Tempo-Traveller-on-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Innova-Crysta-On-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Innova-Cabs-on-Rent-in-Pune" element={<Innovacabsonrentinpune />} />
<Route path="/Volkswagen-Vento-On-Rent" element={<Volkswagenventoonrent />} />
<Route path="/Swift-Dzire-On-Rent-In-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Pune-to-Imagica-Taxi" element={<Punetoimagicataxi />} />
<Route path="/Mini-Bus-On-Rent-in-Pune" element={<Minibusonrentinpune />} />
<Route path="/Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrentinpune />} />
<Route path="/Pune-to-Sambhaji-Nagar-Taxi-fare" element={<Punetosambhajinagartaxifare />} />
<Route path="/Pune-to-Ganpatipule-Cabs" element={<Punetoganapaticabs />} />
<Route path="/Pune-to-Harihareshwar-Taxi-Fare" element={<Punetoharihareshwartaxifare />} />
<Route path="/Pune-to-Alibag-Cabs" element={<Punetoalibaugcabs />} />
<Route path="/Pune-to-Panvel-Cabs" element={<Punetopanvelcabs />} />
<Route path="/Pune-to-Hyderabad-Cabs" element={<Punetohyderabadcabs />} />
<Route path="/Pune-to-5-Jyotrilinga-Cab" element={<Punetofivejyotilingacab />} />
<Route path="/Cab-Booking-in-Pune" element={<Cabbookinginpunne />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookingpune />} />
<Route path="/Explorer-pan-India-cab-service-from-Pune" element={<Explorerpanindiacabservicefrompune />} />
<Route path="/Mumbai-Darshan-Cabs-Service" element={<Mumbaidarshancabsservice />} />
<Route path="/Mumbai-to-Shirdi-Cabs" element={<Mumbaitishirdicabs />} />
<Route path="/Mumbai-Airport-to-Pune-Cabs" element={<Mumbaiairporttopunecab />} />
<Route path="/Mumbai-to-Pune-Cab-Service" element={<Mumbaitopunecabservice />} />
<Route path="/Mumbai-to-Mahabaleshwar-Taxi" element={<Mumbaitomahabaleshwartaxi />} />
<Route path="/Mumbai-to-Konkan-Darshan-Cab" element={<Mumbaitokonkandarshancab />} />
<Route path="/Mumbai-to-Goa-Cab-Service" element={<Mumbaitogoacabservice />} />
<Route path="/Mumbai-to-Nashik-Cab" element={<Mumbaitonashikcab />} />


<Route path="/Mumbai-Airport-Cab-Service" element={<Mumbaiairportcabservice />} />
<Route path="/Mumbai-to-Outstation-Cabs" element={<Mumbaitooutstationcabs />} />
<Route path="/Online-Taxi-Booking-Mumbai" element={<Onlinetaxibookingmumbai />} />
<Route path="/Outstation-Taxi-Service-in-Thane" element={<Outstationtaxiserviceinthane />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Darshan-Cab" element={<Mumbaitofivejyotilingadarshancab />} />
<Route path="/Mumbai-to-Kolhapur-Cabs" element={<Mumbaitokolhapurcabs />} />
<Route path="/Cheapest-Cab-Service-in-Mumbai" element={<Cheapestcabserviceinmumbai />} />
<Route path="/Mumbai-to-Ashtavinayak-Darshan-Cab-Service" element={<Mumbaitoashtavinayakdarshancabservice />} />
<Route path="/Taxi-Service-in-Hadapsar" element={<Taxiserviceinhadapsar />} />
<Route path="/Taxi-Service-in-Lohegaon" element={<Taxiserviceinlohegaon />} />
<Route path="/Cab-Service-in-Viman-Nagar" element={<Cabserviceinvimannagar />} />
<Route path="/One-Way-Cab-Pune" element={<Onewaycabpune />} />

<Route path="/Pune-to-Outstations-Cabs" element={<Punetooustationcabs />} />
<Route path="/Pune-to-Matheran-Cabs" element={<Punetomatherancabs />} />
<Route path="/Pune-to-5-Jyotirlinga-Darshan-Cab" element={<Punetofivejyotilingadarshancabs />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pune-to-Aurangabad-Cab-Service" element={<Punetoaurangabadcab />} />
<Route path="/Pune-to-Nashik-Cab-Service" element={<Punetonashikcabservice />} />
<Route path="/Pune-to-Alibaug-Cab" element={<Punetoalibaugcab />} />
<Route path="/Goa-to-Pune-Cabs" element={<Goatopunecabs />} />
<Route path="/Innova-Crysta-Cab-in-Pune" element={<Innovacrystacabinpune />} />
<Route path="/Pune-to-Ashtavinayak-Cabs" element={<Punetoashtavinayakcabs />} />
<Route path="/Mumbai-Outstation-Cab-Booking" element={<Mumbaioutstationcabbooking />} />
<Route path="/Cab-Service-in-Navi-Mumbai" element={<Cabserviceinnavimumbai />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Innova-Crysta-On-Rent-in-Mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Cab-Service-in-Thane" element={<Cabserviceinthane />} />
<Route path="/Mumbai-to-Alibaug-Cab" element={<Mumbaitoalibaugcab />} />
<Route path="/Navi-Mumbai-International-Airport-Cabs" element={<Navimumbaiinternatinalairportcab />} />


<Route path="/Goa-to-Pune-Cab-Service" element={<Goatopunecabservice />} />
<Route path="/Pune-to-Goa-Innova-Rental" element={<Punetogoainnovarental />} />
<Route path="/Goa-to-Pimpri-Chinchwad-Cab" element={<Goatopimprichichwad />} />
<Route path="/Goa-to-Pune-One-Way-Cab" element={<Goatopuneonewaycab />} />
<Route path="/Goa-to-Pune-Taxi" element={<Goatopunetaxi />} />
<Route path="/Pune-to-Goa-Taxi" element={<Punetogoataxi />} />
<Route path="/Pune-to-Goa-Cab-Package" element={<Punetogoacabpackage />} />
<Route path="/Pune-to-Goa-Innova-Rental" element={<Punetogoataxifare />} />
<Route path="/Pune-to-Goa-Taxi-Fare-One-Way" element={<Punetogoataxifareoneway />} />
<Route path="/Pimpri-Chinchwad-to-Goa-Cab" element={<Pimprichichwadtogoacab />} />
<Route path="/Pune-to-Goa-Taxi-Service" element={<Punetogoataxiservice />} />
<Route path="/Pune-to-Goa-Ertiga-Cab-Booking" element={<Punetogoaertigacabbooking />} />
<Route path="/Pune-to-Goa-Tour-Packages-for-Family" element={<Punetogoatourpackagesforfamily />} />
<Route path="/Pune-to-Goa-2-Days-Package" element={<Punetoogoatwodayspackages />} />
<Route path="/Pune-to-Goa-3-Days-Package" element={<Punetogoathreedayspackages />} />
<Route path="/Pune-to-Goa-Innova-Cab" element={<Punetogoainnnovacab />} />
<Route path="/Goa-Packages-from-Pune-for-Family" element={<Goapackagesfrompuneforfamily />} />
       
      </Routes>
      <Footer />
    </Router>


  );
}

export default App;
